export enum EmailAction {
	RESET_PASSWORD = 'resetPassword',
	RECOVERY_EMAIL = 'recoveryEmail',
	VERIFY_EMAIL = 'verifyEmail',
}
